import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { ReadOnlyLinkRow } from '../../ReadOnlyLinkRow';

export const IncentivesRow = () => {
    const totalRebates = useSelector(offerReduxSelectors.getAppliedIncentivesTotalForDisplay);

    return (
        <ReadOnlyLinkRow
            rowKey="incentives"
            label="Incentives"
            value={formatNumberAndCents(totalRebates)}
            tab={DealTabs.INCENTIVES}
        />
    );
};
